module.exports = __webpack_public_path__ + "static/media/circle-yes.70821b06.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/circle-yes.svg
// module id = 639
// module chunks = 0